import React from 'react';
import { NavLink } from 'react-router-dom';
import Button from '../../shared/buttons/Button';
import TextInput from '../../shared/inputs/TextInput';
import qs from 'qs';
import { login } from '../../api/cloudApiGenerated';

class LoginPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.onLogin = this.onLogin.bind(this);
    this.updateState = this.updateState.bind(this);

    const query = qs.parse(location.search, { ignoreQueryPrefix: true });

    this.state = {
      email: '',
      password: '',
      failure: false,
      overrideRedirect: props?.location?.state?.overrideRedirect,
      shouldRedirect: 'r' in query,
      resetted: Object.prototype.hasOwnProperty.call(query, 'reset'),
      ref: Object.prototype.hasOwnProperty.call(query, 'ref')
    };

    if ('r' in query && this.props.team) {
      this.props.history.push({
        pathname: this.props.paths.profileCharts
      });
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const newTeam = newProps.team;

    if (newProps.anonymous) return;

    if (newTeam && newTeam.id && this.state.shouldRedirect) {
      this.props.history.push({
        pathname: this.props.paths.profileCharts
      });
    }
  }

  onLogin(event) {
    event.preventDefault();

    login(this.state.email, this.state.password)
      .then((data) => {
        this.props.onLoggedIn(false, data);

        if (this.state.overrideRedirect) {
          this.props.history.push({
            pathname: this.props.redirect
          });
        } else if (
          this.state.ref ||
          this.state.shouldRedirect ||
          this.props.redirect ||
          this.props?.location?.state?.from === this.props.paths.frontPage
        ) {
          this.props.history.push({
            pathname: this.props.paths.profileCharts
          });
        } else {
          this.props.history.goBack();
        }
      })
      .catch(() => {
        this.setState({
          failure: true
        });
      });
  }

  updateState(event) {
    const field = event.target.name;
    let state = this.state;
    state[field] = event.target.value;
    return this.setState(state);
  }

  render() {
    return (
      <div className="dark-layout login-page col-xs-12">
        <div className="page-inner-div">
          {this.state.resetted && (
            <div className="reset-trial-notice">
              <div className="header-text">Thank you for activating your 14 day free trial!</div>
              <div clasName="notice-text">
                Simply sign in with one of the options below to get started with all available features.
                <br className="hidden-xs hidden-sm hidden-md " />
                Don’t remember your password? Simply{' '}
                <NavLink to={this.props.paths.forgottenPassword}> click here </NavLink> to request a password change,
                and we&apos;ll send you a link to reset your password.
              </div>
            </div>
          )}

          <section className="page-section">
            <div className="page-form">
              <form id="login-form" role="form" method="post">
                <div className="page-div">
                  <h3>Sign in with email</h3>

                  <TextInput
                    label=""
                    inlineLabel="Email:"
                    name="email"
                    type="email"
                    value={this.state.email}
                    placeholder="Email..."
                    onChange={this.updateState}
                    labelClass={' hidden-xs'}
                  />

                  <TextInput
                    label=""
                    inlineLabel="Password:"
                    name="password"
                    type="password"
                    value={this.state.password}
                    placeholder="Password..."
                    onChange={this.updateState}
                    labelClass={' hidden-xs'}
                  />
                  <p>
                    <NavLink to={this.props.paths.forgottenPassword}>Forgot password?</NavLink>
                  </p>
                  <div className="btn-page-div">
                    <Button
                      buttonText="Sign in"
                      buttonClass="bulk-action bulk-action-btn"
                      type="submit"
                      onClick={this.onLogin}
                    />
                  </div>
                  <p>
                    <NavLink to={this.props.paths.sso}> Sign in with Single Sign On</NavLink>
                  </p>
                  <p>
                    Not Registered?
                    <NavLink to={this.props.paths.signup}> Create an account</NavLink>
                  </p>
                </div>
              </form>
              <div className="page-alternative">
                <h3 className="hidden-xs">Sign in with other accounts</h3>
                <p className="hidden-xs">You can also sign in with one of the following providers:</p>
                <a className="btn-google" href={this.props.paths.oauthSignup}>
                  <img src="/static/images/btn_google_dark_normal_ios.svg" />
                  <span> Sign in with Google </span>
                </a>
              </div>
            </div>
            <div className="message-box">
              {this.state.failure && (
                <div className="alert alert-danger">
                  <strong>Oops!</strong> The email or password is incorrect.
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export default LoginPage;
